/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20260611 by Jan Brunner
 *     all rights reserved.
 */

import { IMSObject, IMSId } from './ims-object';

export class Cellphone extends IMSObject {
  static fromDto(dto: CellphoneDTO, databag?: any) {
    const obj = new this(
      {
        imsId: dto.id,
        secondaryId: undefined,
        objRef: 'ims/Cellphone',
      },
      dto.label,
      dto.phonenumber,
      dto.phonenumber_cleartext,
      dto.name,
      dto.imei,
      dto.type,
      dto.brand,
      dto.typename,
      dto.employee
        ? new IMSObject(Number(dto.employee.id), undefined, dto.employee.label, 'ims/Employee')
        : undefined,
      dto.mobileclient
        ? new IMSObject(Number(dto.mobileclient.id), undefined, dto.mobileclient.label, 'ims/ManagedDevice')
        : undefined,
    );

    obj.databag = databag ?? dto;
    return obj;
  }

  constructor(
    public readonly id: IMSId,
    label: string,
    public phonenumber: string = undefined,
    public phonenumberCleartext: string = undefined,
    public name: string = undefined,
    public imei: string = undefined,
    public type: string = undefined,
    public brand: string = undefined,
    public typename: string = undefined,
    public employee: IMSObject = undefined,
    public mobileclient: IMSObject = undefined,
  ) {
    super(id.imsId, id.secondaryId, label, 'ims/Cellphone');
  }
}

export interface CellphoneDTO {
  id: number;
  label: string;
  phonenumber: string;
  phonenumber_cleartext: string;
  name: string;
  imei: string;
  type: string;
  brand: string;
  typename: string;
  employee?: { id: string; label: string };
  mobileclient?: { id: string; label: string };
}
